<template>
  <a-modal
    :bodyStyle="{ padding: 0 }"
    :mask="true"
    width="80%"
    wrapClassName="attachClass"
    :dialogStyle="{}"
    dialogClass="dialogClass"
    :maskStyle="{}"
    :title="
      (h) => {
        return h('div', [h('span', $t('businessDispatch.viewAttachment'))]);
      }
    "
    :visible="visible"
    @cancel="close"
  >
    <template>
      <div :style="{ height: '100%' }">
        <div :style="{ height: '94%' }">
          <template>
            <div class="attactment-wrap">
              <img
                @mousedown="imgMove"
                :src="imgList[imgIndex]"
                alt=""
                class="imgStyle"
                :style="imgStyle"
                ref="imageBox"
              />
            </div>
          </template>
          <!-- <template v-else-if="imgList[imgIndex]">
            <iframe
              :src="previewFile(imgList[imgIndex])"
              :style="{ height: '100%', width: '100%' }"
              frameborder="0"
            ></iframe>
          </template> -->
        </div>
        <div class="attachment-footer">
          <div class="opt-left"></div>
          <div class="opt-middle">
            <span>
              {{ $t('businessDispatch.accessoryName') }}:
              {{ imgList[imgIndex] ? imgList[imgIndex].substr(-10) : $t('businessDispatch.noInformation') }}
            </span>
          </div>
          <div class="change-img-size">
            <a-button size="small" @click="toBIgChange">
              <a-icon type="zoom-in" />
            </a-button>
            <a-button size="small" @click="toSmallChange">
              <a-icon type="zoom-out" />
            </a-button>
            <a-button size="small" @click="rotateLeft">
              <a-icon type="redo" />
            </a-button>
          </div>
          <!--right-->
          <div class="opt-right">
            <a-row type="flex" justify="space-around" align="middle">
              <a-col
                :span="4"
                :title="$t('previousPage')"
                class="optPage left"
                onselectstart="return false"
              >
                <a-icon
                  type="left"
                  :class="imgIndex == 0 ? 'notAllow' : 'allow'"
                  @click="preImg"
                />
              </a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  class="jup"
                  :title="imgIndex + '/' + imgList.length"
                  v-model.number="currentIndex"
                ></a-input>
                <span style="margin: 0 8px;">/</span>
                <span>{{ imgList.length }}</span>
              </a-col>
              <a-col
                :span="4"
                :title="$t('nextPage')"
                class="optPage right"
                onselectstart="return false"
              >
                <a-icon
                  type="right"
                  :class="imgIndex + 1 == imgList.length ? 'notAllow' : 'allow'"
                  @click="nextImg"
                />
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </template>

    <template slot="footer" class="footer">
      <a-button key="back" @click="close">
        {{ $t('close') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>

export default {
	name: "ImagePreview",
  data() {
    return {
      visible: false,
      imgList: [],
      imgIndex: 0,
      rotateTimes: 0,
      multiples: 1,
      imgStyle: "",
    }
  },
	computed: {
    currentIndex: {
      get: function() {
        return this.imgIndex + 1
      },
      set: function(newValue) {
        if (newValue > this.imgList.length) {
          this.imgIndex = this.imgList.length - 1
        } else if ( newValue > 0) {
          this.imgIndex = newValue - 1
        } else {
          this.imgIndex = 0
        }
      }
    }
  },
	methods: {
    open(imgList, imgIndex = 0) {
      this.imgList = imgList
      this.imgIndex = imgIndex
      this.visible = true
    },
    close() {
      this.visible = false
    },
    //  查看上一个附件
		preImg() {
      if (this.imgIndex > 0) {
        this.imgIndex--
      }
		},
		// 查看下一个附件
		nextImg() {
			if (this.imgIndex < (this.imgList.length - 1)) {
				this.imgIndex++;
			}
		},
    // 旋转图片
		rotateLeft() {
			this.rotateTimes++;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`;
		},
		// 放大
		toBIgChange() {
			if (this.multiples >= 2) {
				return;
			}
			this.multiples += 0.25;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`;
		},
		// 缩小
		toSmallChange() {
			if (this.multiples <= 1) {
				return;
			}
			this.multiples -= 0.25;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`;
		},
		// 实现图片拖拽
		imgMove(e) {
			this.cleanUpDefaultEvent(e);
			let oImg = e.target;
			let disX = e.clientX - oImg.offsetLeft;
			let disY = e.clientY - oImg.offsetTop;
			document.onmousemove = (e) => {
				e.preventDefault();
				let left = e.clientX - disX;
				let top = e.clientY - disY;
				this.imgStyle = this.imgStyle + `left: ${left}px; top:${top}px;`;
			};
			document.onmouseup = () => {
				document.onmousemove = null;
				document.onmousemove = null;
			};
		},
    cleanUpDefaultEvent(event) {
			event = event || window.event || arguments.callee.caller.arguments[0];
			if (event.preventDefault) {
				//IE not have
				event.preventDefault();
			}
			event.returnValue = false;
		},
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-modal-content {
  height: 100%;
}
.jup {
	width: 30px;
	display: inline-block;
	padding: 0;
	text-align: center;
}
.notAllow {
	cursor: not-allowed;
	opacity: 0.5;
}
.allow {
	&:hover {
		cursor: pointer;
		color: #1890ff;
	}
}
.attactment-wrap {
	width: 100%;
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
}
@media screen and (max-width: 768px) {
	/deep/ .ant-modal-content {
		width: 1040px;
	}
}

.attachment-footer {
	height: 6%;
	position: relative;
	display: flex;
	align-items: center;
	background: #c7c5c5;
	font-weight: bold;
}
.change-img-size {
	position: absolute;
	right: 186px;
}
.opt-left {
	width: 4%;
}
.opt-middle {
	width: 46%;
	text-align: left;
}
.opt-right {
	position: absolute;
	right: 10px;
	width: 150px;
}
</style>